import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { ORDER_CREATION_RECEIPT_OPTIONS } from '../constants/receiptOptions';
import { downloadCreatedOrderReceipt } from '../utils/orderReceiptDownload';

const OrderReceiptDropdown = ({
  lastCreatedOrderReceipt,
  options = ORDER_CREATION_RECEIPT_OPTIONS,
}) => {
  const [open, setOpen] = useState(false);

  if (!lastCreatedOrderReceipt) return null;

  const handleDownload = async (lang, format) => {
    await downloadCreatedOrderReceipt(lastCreatedOrderReceipt, lang, toast, format);
    setOpen(false);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="order-action-btn admin-btn-neutral"
      >
        Receipt
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="receipt-menu receipt-menu-up">
            {options.map(({ lang, format, label }) => (
              <button
                key={`${lang}-${format}`}
                type="button"
                onClick={() => handleDownload(lang, format)}
                className="receipt-menu-item"
              >
                {label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default OrderReceiptDropdown;
